import { Helmet } from "react-helmet-async";

const SeoNoIndex = ({ data }) => {
    return (
        <Helmet>
            <title>{data?.title || "Neoosearch"}</title>
            <meta name="description" content={data?.description || "NeooSearch business listing pricing and plans – Pick the right account from Startup to Enterprise with flexible pricing and powerful features to grow your business."} data-rh="true" />
            <meta name="robots" content="noindex, nofollow" />
        </Helmet>
    );
};
export default SeoNoIndex;